import React, { useState } from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Nav.css";
import { useAuth } from "../contexts/AuthContext";
import {
  getReportUseProductionDb,
  isDevDbSwitchAvailable,
  setReportUseProductionDb,
} from "../pages/Test/DataFetcher";

const Navbars = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const isReportOnlyUser = user?.account === "admin1";
  const canViewReport = ["admin", "admin1"].includes(user?.account);
  const [useProductionDb, setUseProductionDb] = useState(
    getReportUseProductionDb(),
  );
  const showDbSwitch = isDevDbSwitchAvailable();
  console.log("user", user);

  const applyDbMode = (nextUseProduction) => {
    if (nextUseProduction === useProductionDb) {
      return;
    }
    setReportUseProductionDb(nextUseProduction);
    setUseProductionDb(nextUseProduction);
    window.location.reload();
  };

  return (
    <Navbar bg="secondary" expand="md">
      <Navbar.Brand
        onClick={() =>
          navigate(isReportOnlyUser ? "/report" : "/EntryPage")
        }
        style={{ color: "white", paddingLeft: "10px", cursor: "pointer" }}
      >
        Home
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="navbar-nav" />
      <Navbar.Collapse id="navbar-nav">
        <Nav className="ml-auto align-items-center">
          {!isReportOnlyUser && (
            <>
              <Nav.Link
                onClick={() => navigate("/EntryPage")}
                style={{ color: "white", cursor: "pointer" }}
              >
                EntryPage
              </Nav.Link>
              <Nav.Link
                onClick={() => navigate("/hansheng")}
                style={{ color: "white", cursor: "pointer" }}
              >
                hansheng
              </Nav.Link>
              <Nav.Link
                onClick={() => navigate("/yoyo")}
                style={{ color: "white", cursor: "pointer" }}
              >
                yoyo
              </Nav.Link>
              <Nav.Link
                onClick={() => navigate("/management")}
                style={{ color: "white", cursor: "pointer" }}
              >
                management
              </Nav.Link>
            </>
          )}
          {user?.account === "dennis" ? (
            <Nav.Link
              onClick={() => navigate("/tokens")}
              style={{ color: "white", cursor: "pointer" }}
            >
              tokens
            </Nav.Link>
          ) : null}
          {canViewReport ? (
            <Nav.Link
              onClick={() => navigate("/report")}
              style={{ color: "white", cursor: "pointer" }}
            >
              report
            </Nav.Link>
          ) : null}
          {!isReportOnlyUser && (
            <Nav.Link
              onClick={() => navigate("/Contact_Me")}
              style={{ color: "white", cursor: "pointer" }}
            >
              Contact_Me
            </Nav.Link>
          )}
          {showDbSwitch ? (
            <div className="db-switch">
              <span className="db-switch__label">DB</span>
              <div className="db-switch__track" role="group" aria-label="資料庫切換">
                <button
                  type="button"
                  className={`db-switch__btn${!useProductionDb ? " is-active is-demo" : ""}`}
                  onClick={() => applyDbMode(false)}
                >
                  Demo
                </button>
                <button
                  type="button"
                  className={`db-switch__btn${useProductionDb ? " is-active is-prod" : ""}`}
                  onClick={() => applyDbMode(true)}
                >
                  正式
                </button>
              </div>
            </div>
          ) : null}
        </Nav>
        <Nav
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            marginRight: "10px",
            gap: "20px",
          }}
        >
          <Nav.Link style={{ color: "white" }}>{user?.account}</Nav.Link>
          <Button
            variant="outline-light"
            onClick={() => {
              window.alert("已經登出系統");
              signOut();
            }}
          >
            Sign out
          </Button>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Navbars;
